//import { mainElement } from "./config-non-constants.js";

import { executeRegisteredAttachEventListeners } from '../js/to-attach-event-listener-registry.js';

function isBrowser() {
  return typeof window !== 'undefined' && typeof document !== 'undefined';
}

// Safely accessing the document object
let mainElement = isBrowser() ? document.querySelector('main') : null;

////wrap master into container
//let masterLayoutX = `<div id="x-my-page-layout">${masterLayout}</div>`;

////wrap page content into container
//let pageContentX = `<div id="x-my-page-content">${content}</div>`;

let _currentMasterPageName = null;

//export const mainElement = isBrowser() ? document.querySelector("main") : null;

// let mainElement = document.querySelector("main");

export async function setFullPageIntoView(
  masterPageName,
  masterPageHtml,
  pageContentHtml,
  pageHeaderTags
) {
  console.log('🌐 SetFullPageIntoView - starting');

  if (!mainElement) {
      console.error('❌ SetFullPageIntoView <main> element not found');
    return;
  }

  try {
    // alert("setFullPageIntoView: " + masterPageName);

    await convertAndSEOResultForDOMAndSet(pageHeaderTags);

    // ─────────────────────────────────────────────────────────────
    // 1️⃣ If the master layout itself changed, re-render it _inside_ <main>
      // ─────────────────────────────────────────────────────────────

      console.log(`🔄 SetFullPageIntoView Current ${_currentMasterPageName} but setting to ${masterPageName}`); 


      if (masterPageName !== _currentMasterPageName) {

         


      // alert(`header changed`);

      // Replace the {{{ content }}} within the masterPageHtml with the actual content
      const newMainHtml = masterPageHtml.replace('{{{ content }}}', pageContentHtml);

      const contentEl = mainElement.querySelector('#x-my-page-layout');
      if (contentEl) {
        const newContentEl = document.createElement('div');
        newContentEl.id = 'x-my-page-layout';
        newContentEl.innerHTML = newMainHtml.trim();
        contentEl.replaceWith(newContentEl);
      }

      _currentMasterPageName = masterPageName;

          console.log(`🔄 SetFullPageIntoView Master layout changed from ${_currentMasterPageName} to ${masterPageName}`);



      } else {

          console.log(`🔄 SetFullPageIntoView master page not changed}`);


      // If the master layout didn't change, just update the page content
      const contentEl = mainElement.querySelector('#x-my-page-content');
      if (contentEl) {
        // contentEl.innerHTML = pageContentHtml;

        const newContentEl = document.createElement('div');
        newContentEl.id = 'x-my-page-content';
        newContentEl.innerHTML = pageContentHtml.trim();
        contentEl.replaceWith(newContentEl);

      
      } else {
        alert(`hreplacer fallback`);

        // Replace content in the masterPageHtml with pageContentHtml
        const newMainHtml = masterPageHtml.replace('{{{ content }}}', pageContentHtml);

        // Parse the entire new <main> element from the resulting HTML
        const tempWrapper = document.createElement('div');
        tempWrapper.innerHTML = newMainHtml.trim();

        const newMainEl = tempWrapper.querySelector('main');

        if (newMainEl) {
          mainElement.replaceWith(newMainEl);
          alert('Fallback: replaced entire <main> element without innerHTML flicker.');
        } else {
          console.error('❌ No <main> found in the fallback content.');
        }

      
      }
    }

    window.scrollTo(0, 0);
    executeRegisteredAttachEventListeners();

    console.log('✅ SetFullPageIntoView complete');
  } catch (err) {
    console.error('❌ Error in SetFullPageIntoView:', err);
  }
}

export function convertAndSEOResultForDOMAndSet(result) {
    console.log('🚀 convertSEOResultForDOM - starting');

    if (!result) {
        console.warn('⚠️ No SEO result provided');
        return;
    }

    const { metaTitle, metaDescription, metaKeywords, metaFollowIndexTag, pageSEOCanonical } = result;

    // ✅ Clear existing tags
    removeExistingSEOTags();

    // ✅ 1. Set <title> first
    setTitleTag(metaTitle);

    // ✅ 2. Set <meta name="..."> (description, keywords, robots)
    setMeta('description', metaDescription);
    setMeta('keywords', metaKeywords);
    setMeta('robots', metaFollowIndexTag);

    // ✅ 3. Set Open Graph only (in order)
    setMetaProperty('og:title', metaTitle);
    setMetaProperty('og:description', metaDescription);
    setMetaProperty('og:url', getCanonicalHref(pageSEOCanonical));

    // ✅ 4. Set Twitter after Open Graph
    setMeta('twitter:title', metaTitle);
    setMeta('twitter:description', metaDescription);
    setMeta('twitter:url', getCanonicalHref(pageSEOCanonical));

    // ✅ 5. Set canonical/alternate links
    setCanonicalAndAlternateLinks(pageSEOCanonical);
}




function removeExistingSEOTags() {
    // Remove <title>
    const existingTitle = document.querySelector('title');
    if (existingTitle) existingTitle.remove();

    // Remove standard <meta name="...">
    ['description', 'keywords', 'robots'].forEach(name => {
        const el = document.querySelector(`meta[name='${name}']`);
        if (el) el.remove();
    });

    // Remove <link rel="canonical"> and <link rel="alternate">
    document
        .querySelectorAll("link[rel='canonical'], link[rel='alternate']")
        .forEach(el => el.remove());

    // Remove Open Graph meta tags
    [
        'og:title', 'og:description', 'og:url', 'og:type',
        'og:image', 'og:site_name', 'og:locale'
    ].forEach(property => {
        const el = document.querySelector(`meta[property='${property}']`);
        if (el) el.remove();
    });

    // Remove Twitter meta tags
    [
        'twitter:title', 'twitter:description', 'twitter:url',
        'twitter:image', 'twitter:card', 'twitter:site'
    ].forEach(name => {
        const el = document.querySelector(`meta[name='${name}']`);
        if (el) el.remove();
    });
}





function setTitleTag(metaTitle) {
  let titleEl = document.head.querySelector('title');


  if (!titleEl) {
    titleEl = document.createElement('title');
    titleEl.textContent = metaTitle;
    document.head.appendChild(titleEl);

    // alert(`title tag updated`);
  } else {
    titleEl.textContent = metaTitle;

    // document.title = "dddddddddddddddddddd";
    // alert(`title tag found xxx updatedtitleEl: " + titleEl + ": value : " + titleEl.textContent`);
  }
}


//function setCanonicalAndAlternateLinks(rawLinkTags) {
//  if (!rawLinkTags) return;

//  const tempDiv = document.createElement('div');
//  tempDiv.innerHTML = rawLinkTags;

//  const linkElements = tempDiv.querySelectorAll("link[rel='canonical'], link[rel='alternate']");

//  linkElements.forEach(link => {
//    document.head.appendChild(link);
//  });
//}


//function setCanonicalAndAlternateLinks(rawLinkTags) {
//    if (!rawLinkTags) return;

//    const tempDiv = document.createElement('div');
//    tempDiv.innerHTML = rawLinkTags;

//    const linkElements = tempDiv.querySelectorAll("link[rel='canonical'], link[rel='alternate']");

//    linkElements.forEach(link => {
//        const rel = link.getAttribute('rel');
//        const hreflang = link.getAttribute('hreflang');
//        let href = link.getAttribute('href');

//        // ✅ Only for homepage: rewrite canonical /en → /
//        if (rel === 'canonical' && isHomePage() && /^https:\/\/towobo\.com\/en\/?$/.test(href)) {
//            href = 'https://towobo.com';
//            link.setAttribute('href', href);
//        }

//        // ✅ Only for homepage: rewrite x-default /en → /
//        if (
//            rel === 'alternate' &&
//            hreflang?.toLowerCase() === 'x-default' &&
//            isHomePage() &&
//            /^https:\/\/towobo\.com\/en\/?$/.test(href)
//        ) {
//            href = 'https://towobo.com';
//            link.setAttribute('href', href);
//        }

//        document.head.appendChild(link);
//    });
//}


function setCanonicalAndAlternateLinks(rawLinkTags) {
    if (!rawLinkTags) return;

    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = rawLinkTags;

    const linkElements = tempDiv.querySelectorAll("link[rel='canonical'], link[rel='alternate']");

    linkElements.forEach(link => {
        const rel = link.getAttribute('rel');
        const hreflang = link.getAttribute('hreflang');
        let href = link.getAttribute('href');

        if (isHomePage()) {
            for (const code of supportedLanguageCodes) {
                const langRegex = new RegExp(`^https:\/\/towobo\\.com\\/${code}\\/?$`);

                // ✅ Canonical cleanup
                if (rel === 'canonical' && langRegex.test(href)) {
                    href = 'https://towobo.com';
                    link.setAttribute('href', href);
                    break;
                }

                // ✅ x-default alternate cleanup
                if (
                    rel === 'alternate' &&
                    hreflang?.toLowerCase() === 'x-default' &&
                    langRegex.test(href)
                ) {
                    href = 'https://towobo.com';
                    link.setAttribute('href', href);
                    break;
                }
            }
        }

        document.head.appendChild(link);
    });
}



function isHomePage() {
    const path = window.location.pathname.replace(/\/+$/, ''); // remove trailing slashes
    return path === '' || path === '/';
}



function mySetOpenGraphTags(metaTitle, metaDescription, pageSEOCanonical) {
  setMetaProperty('og:title', metaTitle);
  setMetaProperty('og:description', metaDescription);
  setMetaProperty('og:url', getCanonicalHref(pageSEOCanonical));

  // Optional Twitter tags (if desired)
  setMetaProperty('twitter:title', metaTitle);
  setMetaProperty('twitter:description', metaDescription);
  setMetaProperty('twitter:url', getCanonicalHref(pageSEOCanonical));
}



function setMeta(name, content) {
    if (!content) return;
    let el = document.querySelector(`meta[name='${name}']`);
    if (!el) {
        el = document.createElement('meta');
        el.setAttribute('name', name);
        document.head.appendChild(el);
    }
    el.setAttribute('content', content);
}

function setMetaProperty(property, content) {
  if (!content) return;
  const existing = document.querySelector(`meta[property='${property}']`);
  if (existing) {
    existing.setAttribute('content', content);
  } else {
    const el = document.createElement('meta');
    el.setAttribute('property', property);
    el.setAttribute('content', content);
    document.head.appendChild(el);
  }
}

//function getCanonicalHref(rawLinkTags) {
//  if (!rawLinkTags) return '';
//  const match = rawLinkTags.match(/<link rel="canonical" href="([^"]+)"\s*\/?>/);
//  return match ? match[1] : '';
//}

//function getCanonicalHref(rawLinkTags) {
//    if (!rawLinkTags) return '';

//    const match = rawLinkTags.match(/<link rel="canonical" href="([^"]+)"\s*\/?>/i);
//    if (!match) return '';

//    let href = match[1];

//    // ✅ Only replace if on base URL (homepage) and canonical ends with /en
//    if (isHomePage() && /^https:\/\/towobo\.com\/en\/?$/.test(href)) {
//        href = 'https://towobo.com';
//    }

//    return href;
//}

const supportedLanguageCodes = ['en', 'us', 'fr', 'es', 'de', 'zh', 'it', 'pt', 'tr', 'ja', 'ko', 'ar'];


function getCanonicalHref(rawLinkTags) {
    if (!rawLinkTags) return '';

    const match = rawLinkTags.match(/<link rel="canonical" href="([^"]+)"\s*\/?>/i);
    if (!match) return '';

    let href = match[1];

    // ✅ Remove any /xx if it's a supported language and we're on the homepage
    if (isHomePage()) {
        for (const code of supportedLanguageCodes) {
            if (new RegExp(`^https:\/\/towobo\\.com\\/${code}\\/?$`).test(href)) {
                href = 'https://towobo.com';
                break;
            }
        }
    }

    return href;
}



// ─────────────────────────────────────────────────────────────
// Expose getters / setters so other modules can peek or reset
// ─────────────────────────────────────────────────────────────
export function getCurrentMasterVersion() {
  return _currentMasterPageName;
}

export function setCurrentMasterVersion(htmlString) {
  _currentMasterPageName = htmlString;
}

export function clearCurrentMasterVersion() {
  _currentMasterPageName = null;
}

export function getCurrentPageVersion() {
  return _currentPageVersion;
}

export function clearCurrentPageVersion() {
  _currentPageVersion = null;
}
